import { withStyles } from "@material-ui/core/styles";
import PanelAction from "./../../Pickups/PickupManagement/components/Action";

const styles = (theme) => ({
  submitButton: {
    minWidth: "unset",
  },
  dialogFooter: {
    alignSelf: "flex-end"
  }
});

export default withStyles(styles)(PanelAction);
